import * as React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { List } from 'immutable'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { CustomBlockData } from '../types.mod'
import { ExtraImages } from '../../../utils/extra_images.mod'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../../public_site.main.mod'
import { parseMediaUrl } from '../../../../drupal/drupal_to_cms.mod'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { ParsedParagraphCarrouselImage } from '../../../../drupal/types_and_parser/extra_types.mod'

export type carrouselBlockProps = {
  block_index: number
  field_images: List<ParsedParagraphCarrouselImage>
  current_image: number
  overlay: boolean
}

export type carrouselBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  figure_classname: string
  image_classname: string
  navigation_classname: string
  navigation_text_classname: string
  clickable_classname: string
  secondary_clickable_classname: string
  figcaption_classname: string
  caption_classname: string
}>

export function carrouselBlock(
  props: carrouselBlockProps,
  options?: { style: carrouselBlockStyle; key?: string }
): (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
  return (s: CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: set_state => {

        const set_block_state = (bs: carrouselBlockProps) => set_state(s => {
          let block = s.blocks.get(props.block_index)
          if (block.kind == 'carrouselBlock') block.value.fst = bs
          return s
        })

        const set_current_image = (index: number) => {
          index = index < props.field_images.count() 
            ? index < 0 
              ? props.field_images.count() - 1 
              : index
            : 0
          set_block_state({...props, current_image: index})
        }

        if (props.current_image >= props.field_images.count()) set_current_image(0)
        let field_image = props.field_images.get(props.current_image)
        let image = field_image.field_carrousel_image.thumbnail
        
        return <section className={getClassName(options, "block_classname", "container")} key={options && options.key ? options.key : "carrousel-block"}>
          <div className={getClassName(options, "inner_classname", "py-5")}>
            <div className={getClassName(options, "content_classname", "")}>
              <figure className={getClassName(options, "figure_classname", "")}>
                {/* @FIXME: Don't show overlay on mobile */}
                <img 
                  src={parseMediaUrl(image.image.url)} 
                  alt={image.alt} 
                  onClick={_ => set_block_state({...props, overlay: true})}
                  className={getClassName(options, "image_classname", "w-100")}
                />
              </figure>
              { field_image.field_caption &&
                <figcaption className={getClassName(options, "figcaption_classname", "")}>
                  <p className={getClassName(options, "caption_classname", "small text-secondary text-center mt-2")}>{field_image.field_caption}</p>
                </figcaption>
              }
              <div className={getClassName(options, "navigation_classname", "")}>
                <button onClick={_ => set_current_image(props.current_image - 1)} className={getClassName(options, "clickable_classname", "")}>
                  <svg className="block__icon" height="16" width="10">
                    <use xlinkHref="#chevron--left"/>
                  </svg>
                </button>
                <p className={getClassName(options, "navigation_text_classname", "")}>
                  <span>{props.current_image + 1}</span> / {props.field_images.count()}
                </p>
                <button onClick={_ => set_current_image(props.current_image + 1)} className={getClassName(options, "secondary_clickable_classname", "")}>
                  <svg className="block__icon" height="16" width="10">
                    <use xlinkHref="#chevron--right"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

        
          {props.overlay && <div className="popup popup--gallery">
            <div className="popup__overlay" onClick={_ => set_block_state({...props, overlay: false})}/>
            <div className="popup__content">
              <button className="popup__button" onClick={_ => set_block_state({...props, overlay: false})}>
                <svg className="popup__icon" height="16" width="16">
                  <use xlinkHref="#icon--closing"/>
                </svg>
              </button>
              <figure className={getClassName(options, "figure_classname", "")}>
                <img 
                  src={parseMediaUrl(image.image.url)} 
                  alt={image.alt} 
                  onClick={_ => set_block_state({...props, overlay: true})}
                  className={getClassName(options, "image_classname", "w-100")}
                />
              </figure>
              <div className="popup__footer">
                <div className="popup__nav">
                  <button onClick={_ => set_current_image(props.current_image - 1)} className={getClassName(options, "clickable_classname", "")}>
                    <svg className="block__icon" height="16" width="10">
                      <use xlinkHref="#chevron--left"/>
                    </svg>
                  </button>
                  <p className={getClassName(options, "navigation_text_classname", "")}>
                    <span>{props.current_image + 1}</span> / {props.field_images.count()}
                  </p>
                  <button onClick={_ => set_current_image(props.current_image + 1)} className={getClassName(options, "secondary_clickable_classname", "")}>
                    <svg className="block__icon" height="16" width="10">
                      <use xlinkHref="#chevron--right"/>
                    </svg>
                  </button>
                </div>
                { field_image.field_caption &&
                  <figcaption className={getClassName(options, "figcaption_classname", "")}>
                    <p className={getClassName(options, "caption_classname", "small text-secondary text-center mt-2")}>{field_image.field_caption}</p>
                  </figcaption> 
                }
              </div>
            </div>
          </div>}
        </section>
      }
    })
}
